import axios from "axios";

export default {
  /**
   * Fetch all blog posts
   * @param {string} type - Post type (e.g., 'blog_post')
   * @param {string} lang - Language code (e.g., 'en', 'fr')
   * @param {number} perPage - Number of items per page
   * @param {number} page - Page number
   * @returns {Promise} Promise object represents the blog posts with pagination metadata
   */
  getAllPosts(type, lang, perPage = 15, page = 1) {
    return axios.get("/blog/posts", {
      params: {
        type,
        lang,
        per_page: perPage,
        page,
        status: 'published',
      },
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },

  /**
   * Fetch a single blog post by ID
   * @param {number|string} id - The ID of the blog post
   * @returns {Promise} Promise object represents the blog post
   */
  getPostById(id) {
    return axios.get(`/blog/posts/${id}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },

  /**
   * Get image URL using the backend API
   * @param {string} imagePath - The image path from the blog post data
   * @returns {string} The complete image URL using the backend API
   */
  getImageUrl(imagePath) {
    if (!imagePath) return '';
    
    // Extract the path from the full URL if it's already a complete URL
    let path = imagePath;
    if (imagePath.startsWith('http')) {
      // Extract the path part after the domain
      const url = new URL(imagePath);
      path = url.pathname.substring(1); // Remove leading slash
    }
    
    // Construct the API URL using axios base URL
    const baseURL = axios.defaults.baseURL || '';
    return `${baseURL}/filesmodule/download?path=${encodeURIComponent(path)}`;
  },
};
